/**
 * Tasks related methods are kept here
 */

import axios, { baseRequestConfig } from './base';

// naming convention, http method + function name
export function getTaskTypes(data) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      ...data,
    },
  });
}

export function getTaskDetails(userToken, taskId) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_get_viewdata',
        values: {
          detail: 'FULL',
          task_id: taskId,
        },
      },
    },
  });
}


// method to get task list, browsing mode
export function getTaskList(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_browse',
        values,
      },
    },
  });
}

export function getNewTaskId(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_get_id',
      },
    },
  });
}

// method to get my tasks for the scoped user
export function getUserTaskList(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_mytasks_get',
        values,
      },
    },
  });
}


export function addTaskToUser(userToken, taskId, register) {
  // Follow: register === 0
  // Register: register === 1
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_mytasks_add',
        values: {
          task_id: taskId,
          user_registered: register,
        },
      },
    },
  });
}


export function removeTaskFromUser(userToken, taskId, register) {
  // Follow: register === 0
  // Register: register === 1
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_mytasks_rem',
        values: {
          task_id: taskId,
          user_registered: register,
        },
      },
    },
  });
}


// method to reorder mytasks
export function resortUserTaskList(userToken, taskRankRange, taskList, userRegistered) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_mytasks_resort',
        values: {
          task_rank_range: taskRankRange,
          task_list: taskList,
          user_registered: userRegistered,
        },
      },
    },
  });
}

export function reorderTaskMedia(userToken, taskId, taskDataRankRange, taskDataList) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_data_resort',
        values: {
          task_id: taskId,
          task_data_rank_range: taskDataRankRange,
          task_data_list: taskDataList,
        },
      },
    },
  });
}
// method to add/update a task
export function editTask(userToken, task) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_edit',
        values: {
          ...task,
        },
      },
    },
  });
}


// method to get edit details of a task
export function getTaskEditDetails(userToken, taskId) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_edit_get',
        values: {
          task_id: taskId,
        },
      },
    },
  });
}


// method to get details of a task
export function getTaskEditDefaults(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_edit_defaults',
      },
    },
  });
}

// method to get details of a task
export function taskGetPeople(userToken, taskId, list) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_get_viewpeople',
        values: {
          task_id: taskId,
          list,
        },
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/tasks.js